module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/main-bg_f831c68012825891206bbb9f8c7f2ee5.jpg";